"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import FullSizeLoading from "components/FullSizeLoading";

const Root = () => {
  const router = useRouter();

  useEffect(() => {
    router.push("/dashboard");
  }, [router]);

  return <FullSizeLoading />;
};

export default Root;
